/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import InfoCards from "../../components/TransitionPageComp/InfoCards/InfoCards";
import DashboardSection from "./DashboardSection";
import PercentageIndicator from "../../atomicComponents/PercentageIndicator/PercentageIndicator";
import axios from "axios";
import config from "../../config/config";
import { setQuarter } from "date-fns";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TileComp from "./TileComp/TileComp";
import TileCardDual from "./DualCircleCards/TileCardsDual";
import HorizentalTileCardDual from "./DualCircleCards/HorizentalCard";
import PerformanceLogic from "./PerformanceLogic/PerformanceLogic";
import DashboardMatrix from "./DashboardMatrix/DashboardMatrix";
import StatusTile from "./StatusTile/StatusTile";
// import InfoIcon from "./TileComp/InfoIcon";
import NewInfoIcon from "./TileComp/NewInfoIcon";
import DonutTile from "./GaugeChart";
import Marquee from "react-fast-marquee";


function VendorPaymentSchemeMainPage() {
  const { API_BASE_URL } = config;

  const history = useHistory();

  const token = localStorage.getItem('ApiToken');

  const quarterOptionss = [
    // { value: "undefined", label: "Select" },
    // { value: "0", label: "-All-" },
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const monthOptionss = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const quarterToMonths = {
    2: ["4", "5", "6"], // Apr–Jun
    3: ["7", "8", "9"], // Jul–Sep
    4: ["10", "11", "12"], // Oct–Dec
    1: ["1", "2", "3"], // Jan–Mar
  };

  // const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();

  const { showPopup } = usePopupManager();

  const [hasApplied, setHasApplied] = useState(false);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);

  const [RefreshedDate, setRefreshedDate] = useState([]);

  const currentDateTime = new Date;
  const yeasterdayDate = new Date(currentDateTime);
  yeasterdayDate.setDate(currentDateTime.getDate()-1);
  const stripedYesterrdayDate = yeasterdayDate.toLocaleDateString();

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [quarter, setQuarter] = useState([]);
  const [month, setMonth] = useState([]);

  const [VendorPaymentData, setVendorPaymentData] = useState([]);

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    quarterData: null,
    monthData: null,
    entityList: entityOptions,
    yearList: yearOptions,
    monthList: monthOptionss,
  };

  const [filters, setFilters] = useState(initialFilters);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };
  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-entity-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data[0].all);
        });
    } catch (error) {
      console.error("Error fetching finance-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-year-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-year options:", error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-month-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchRefreshedDate = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-Refreshed-Date`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setRefreshedDate(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters((prev) => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters((prev) => ({ ...prev, yearData: selected }));
  };

  // const handleQuarterChange = (selected) => {
  //   setQuarter(selected);
  //   setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  // const handleQuarterChange = (selected) => {
  //   console.log("selected quater-----------:",selected);
  //   if(selected){
  //     setQuarter(selected);
  //     setFilters(prev => ({ ...prev, quarterData: selected }));
  //   } else {
  //     setQuarter([])
  //   }

  //   if (selected?.value) {
  //     // console.log("Month Options ----->",selected?.value)
  //     setMonth(
  //       monthOptions.filter((m) =>
  //       quarterToMonths[selected.value].includes(m.value)
  //       )
  //     );
  //     setFilters(prev => ({
  //       ...prev,
  //       monthData: monthOptions.filter(m =>
  //         quarterToMonths[selected?.value]?.includes(m.value) // Safe access
  //       )
  //     }));
  //   } else {
  //     setMonth([]);
  //   }
  //   // setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters((prev) => ({ ...prev, quarterData: selected }));

      // Collect all months from selected quarters
      const selectedMonths = selected.flatMap(
        (q) => quarterToMonths[q.value] || []
      );
      // Filter available month options based on selected months
      const filteredMonths = monthOptionss.filter((m) =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters((prev) => ({ ...prev, monthData: filteredMonths }));
    } else {
      // No quarter selected
      setQuarter([]);
      setMonth([]);
      setFilters((prev) => ({
        ...prev,
        quarterData: [],
        monthData: [],
      }));
    }
  };

  const handleMonthChange = (selected) => {
    // setMonth(selected);
    if (selected) {
      setMonth(selected);
      setFilters((prev) => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  const hasRedirected = useRef(false);

  const handleApply = (changed = {}) => {
    const entityFilterData = entity?.value || "";
    const yearFilterData = year?.value || "";
    // const yearFilterData = year?.map((m) => m?.value) || [];
    const monthFilterData = month?.map((m) => m?.value) || [];
    const quarterData = quarter?.map((m) => m?.value) || [];

    setFilters((prev) => ({ ...prev, entityList: entityOptions }));
    setFilters((prev) => ({ ...prev, yearList: yearOptions }));
    setFilters((prev) => ({ ...prev, monthList: monthOptionss }));

    if (hasRedirected.current) return;

    const entityRouteMap = {
      agratas: "/Procure-To-Pay/Agratas-Main",
      jlr: "/Procure-To-Pay/JLR-Main",
    };

    const entityValue = entity?.value?.toLowerCase();
    const routeKey = Object.keys(entityRouteMap).find((key) =>
      entityValue?.includes(key)
    );

    if (routeKey) {
      hasRedirected.current = true;
      history.push(entityRouteMap[routeKey], {
        entityData: entity,
        yearData: year,
        quarterData: quarter,
        monthData: month,
      });
    }

    if (entityFilterData === "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    // if (Array.isArray(entityFilterData) && entity.length === 0) {
    //   showPopup({
    //     type: MESSAGE_TYPE.INFORMATION,
    //     contextText: MESSAGE_TYPE.INFORMATION,
    //     info: "Please select entity.",
    //   });
    //   return;
    // }

    if (Array.isArray(yearFilterData) && yearFilterData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setIsLoading(true);

    const fetchVendorPaymentData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/P2P-VendorPayment`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                // Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            const result = response.data;
            setVendorPaymentData(result);

            setShowDashboard(true);
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Error fetching total contract value options:", error);
      }
    };

    fetchVendorPaymentData();
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setQuarter(null);
    setMonth(null);
    setFilters({
      entityData: null,
      yearData: null,
      quarterData: null,
      monthData: null,
    });
    setShowDashboard(false);
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    // fetchQuarterOptions();
    fetchMonthOptions();
    fetchRefreshedDate();
  }, []);

  useEffect(() => {
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      let shouldApply = false;

      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData.value
        );
        if (ent) {
          setEntity(ent);
          shouldApply = true;
        }
      }

      if (filters.yearData) {
        const yr = yearOptions.find(
          (opt) => opt.value === filters.yearData.value
        );
      //   const yr = yearOptions.filter((opt) =>
      //   filters.yearData.some((m) => m.value === opt.value)
      // );
        if (yr) {
          setYear(yr);
          shouldApply = true;
        }
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptionss.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) {
          setMonth(mon);
          shouldApply = true;
        }
      }

      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptionss.filter((opt) =>
          filters.quarterData.some((m) => m.value === opt.value)
        );
        if (qtr.length > 0) {
          setQuarter(qtr);
          shouldApply = true;
        }
      }

      if (shouldApply) {
        setHasApplied(true);
      }
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      // alert("clicked")
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
  const amberGradient = 'linear-gradient(135deg, #FBBF24 0%, #F97316 100%)';


  const downloadDataDyanmically = async (name) => {
    try {
      const entityFilterData = entity?.value || '';
      const yearFilterData = year?.value || '';
      const monthFilterData = month?.map(m => m?.value) || [];
      const bodyData = {
        entity: entityFilterData,
        year: yearFilterData,
        month: monthFilterData,
        report:name,
        application:"ProcureToPay"
      };

      const response = await fetch(`${API_BASE_URL}/api/download-data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          // Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error("Failed to download CSV");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}_data.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  }

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year
            <span style={{ color: "red" }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti={true}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptionss}
                isSearchable={true}
                isMulti={true}
                styles={customStyles}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            ></div>
            <p
              className="mb-3"
              style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}
            >
              Loading...
            </p>
          </div>
        </div>
      )}
      {showDashboard && (
        <div>
        <div className="row">
          <div className="col-lg-12">
          <DomainTile
                title="Vendor Payment Scheme"
                showBackButton={true}
                mainPagePath="/Procure-To-Pay"
                detailState={filters}
              />
            <DashboardSection
              title="Vendor Payment Scheme"
              disableDetailView={false}
              detailPath="/Procure-To-Pay/Vendor-Payment-Scheme/Detail-Page"
              detailState={filters}
              popupContent="Manual CSV DATA"
              disableInfoIcon={false}
            >
              <div >
              <div
                className="subdivcontainerp2p"
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingTop: "10px",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                  borderRadius: "10px",
                  position: "relative",
                }}
              >
                <div style={{ marginTop: "30px" }}>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            {/* <StatusTile
                            title="MSME Reach Coverage"
                            value={VendorPaymentData["MEMReach"]?.[0]?.[0] ?? "0"}
                            statuses={["green", "#c9c9c9", "#c9c9c9"]}
                            /> */}
                            <DonutTile
                            title="MSME Reach Coverage"
                            dataValue={VendorPaymentData["MEMReach"]?.[0]?.[0] ?? "0"}
                            remainingValue={
                                100 - (VendorPaymentData["MEMReach"]?.[0]?.[0] ?? "0")
                            }
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">                  
                            {/* <StatusTile
                            title="Direct Cash Benefit from TML Funded Scheme"
                            value={VendorPaymentData["DirectCash"]?.[0]?.[0] ?? "0"}
                            statuses={["green", "#c9c9c9", "#c9c9c9"]}
                            /> */}
                            <DonutTile
                            title="Direct Cash Benefit from TML Funded Scheme"
                            dataValue={VendorPaymentData["DirectCash"]?.[0]?.[0] ?? "0"}
                            remainingValue={
                                100 - (VendorPaymentData["DirectCash"]?.[0]?.[0] ?? "0")
                            }
                            />
                        </div>
                    </div>
                </div>
              </div>
              </div>
            </DashboardSection>
          </div>
        </div>
        <div className="row" style={{fontSize:"12px", color:"red"}}>
          <Marquee speed={30} gradient={false}>
          Last Refresh Date:- <b>{stripedYesterrdayDate}</b>
          </Marquee>
        </div>
      </div>
      )}
    </>
  );
}

export default VendorPaymentSchemeMainPage;
